import { render, staticRenderFns } from "./MatchTable.vue?vue&type=template&id=1491ed13&scoped=true&"
import script from "./MatchTable.vue?vue&type=script&lang=js&"
export * from "./MatchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491ed13",
  null
  
)

export default component.exports